module.exports = __webpack_public_path__ + "img/sec2_26.ed05ec79.png";